/** @format */

import { Checkbox, Stack } from "@mui/material";

export const totalBillingConfirmationColumn = [
  {
    key: "methodPayment",
    label: "",
    align: "left",
    isGroup: true,
    dataKey: "index",
    cellProps: {
      minWidth: 20,
      width: "5%",
      rowCell: {
        borderRight: "1px solid #e0e0e0",
      },
    },
  },
  {
    key: "bankName",
    label: "",
    align: "left",
    cellProps: {
      width: "13.5%",
      minWidth: 20,
    },
    render: ({ methodPayment, bankName }) =>
      methodPayment === "引落" ? (bankName ? bankName : "他の") : "",
  },
  {
    key: "lastBilled",
    label: "前回請求額",
    align: "right",
    cellProps: {
      width: "13.5%",
      minWidth: 20,
    },
    render: (item) =>
      new Intl.NumberFormat().format(item?.lastBilled.toFixed(0)),
  },
  {
    key: "lastDeposit",
    label: "今回入金額",
    align: "right",
    cellProps: {
      width: "13.5%",
      minWidth: 20,
    },
    render: (item) =>
      new Intl.NumberFormat().format(item?.lastDeposit.toFixed(0)),
  },
  {
    key: "number",
    label: "件数",
    align: "right",
    cellProps: {
      width: "13.5%",
      minWidth: 20,
    },
    render: (item) => new Intl.NumberFormat().format(item?.number.toFixed(0)),
  },
  {
    key: "withdrawal",
    label: "引落申請済数",
    align: "right",
    cellProps: {
      width: "13.5%",
      minWidth: 20,
    },
    render: (item) =>
      new Intl.NumberFormat().format(item?.withdrawal.toFixed(0)),
  },
  {
    key: "thisSale",
    label: "今回売上額",
    align: "right",
    cellProps: {
      width: "13.5%",
      minWidth: 20,
    },
    render: (item) => new Intl.NumberFormat().format(item?.thisSale.toFixed(0)),
  },
  {
    key: "thisBilled",
    label: "今回請求額",
    align: "right",
    cellProps: {
      width: "13.5%",
      minWidth: 20,
    },
    render: (item) =>
      new Intl.NumberFormat().format(item?.thisBilled.toFixed(0)),
  },
];

export const billingConfirmColumn = (
  selectedAll,
  selected,
  selectedPrint,
  billingConfirmData,
  selectWithDrawal,
  selectedWithdrawal,
  listBuyerNo
) => [
  {
    key: "checkBox",
    label: () => (
      <Stack direction="row" alignItems="center">
        <Checkbox
          checked={
            listBuyerNo.filter((i) =>
              selectedPrint.map((e) => e.buyerNo).includes(i)
            ).length === listBuyerNo.length
          }
          onChange={(_e, value) => selectedAll(value)}
        />
        印刷
      </Stack>
    ),
    align: "left",
    cellProps: {
      minWidth: 10,
    },
    render: (item) => (
      <Checkbox
        checked={selectedPrint.map((e) => e.buyerNo).includes(item.buyerNo)}
        onChange={(_e, value) => selected(value, item)}
      />
    ),
  },
  {
    key: "buyerNo",
    label: "",
    align: "right",
    cellProps: {
      minWidth: 10,
    },
    render: (item) => {
      return typeof item.buyerNo === "number"
        ? new Intl.NumberFormat().format(item?.buyerNo)
        : item.buyerNo;
    },
  },
  {
    key: "buyerName",
    label: "買人",
    align: "left",
    cellProps: {
      width: "30%",
      minWidth: 20,
    },
  },
  {
    key: "lastBilled",
    label: "前回請求額",
    align: "right",
    cellProps: {
      width: "10%",
      minWidth: 20,
    },
    render: (item) => {
      return typeof item.lastBilled === "number"
        ? new Intl.NumberFormat().format(item?.lastBilled.toFixed(0))
        : item.lastBilled;
    },
  },
  {
    key: "lastDeposit",
    label: "今回入金額",
    align: "right",
    cellProps: { width: "10%", minWidth: 20 },
    render: (item) => {
      return typeof item.lastDeposit === "number"
        ? new Intl.NumberFormat().format(item?.lastDeposit.toFixed(0))
        : item.lastDeposit;
    },
  },
  {
    key: "methodPayment",
    label: "支払方法",
    align: "left",
    cellProps: { width: "10%", minWidth: 20 },
    render: ({ methodPayment, bankName }) =>
      methodPayment === "引落"
        ? `${methodPayment} (${bankName ? bankName : "他の"})`
        : methodPayment,
  },
  {
    key: "withdrawal",
    label: "引落申請済",
    align: "right",
    cellProps: { width: "10%", minWidth: 20 },
    render: (item) => {
      return item?.methodPayment === "引落" ? (
        <Checkbox
          defaultChecked={item?.withdrawal}
          checked={
            selectedWithdrawal.map(({ buyerNo }) => buyerNo === item.buyerNo)[0]
              ?.value
          }
          onChange={(_e, value) => selectWithDrawal(value, item)}
        />
      ) : null;
    },
  },
  {
    key: "thisSale",
    label: "今回売上額",
    align: "right",
    cellProps: { width: "10%", minWidth: 20 },
    render: (item) => {
      return typeof item.thisSale === "number"
        ? new Intl.NumberFormat().format(item?.thisSale.toFixed(0))
        : item.thisSale;
    },
  },
  {
    key: "thisBilled",
    label: "今回請求額",
    align: "right",
    cellProps: { width: "10%", minWidth: 20 },
    render: (item) => {
      return typeof item.thisBilled === "number"
        ? new Intl.NumberFormat().format(item?.thisBilled.toFixed(0))
        : item.thisBilled;
    },
  },
];
